// en.js
export default {
  // Login page
  'Please login to your account': 'Please login to your account',
  'Login': 'Login',
  'Forgot Password': 'Forgot Password',
  'Back to Login': 'Back to Login',
  'Get Mobile App': 'Get Mobile App',
  'Username': 'Username',
  'Password': 'Password',
  'Get Mail': 'Get Mail',
  'Password is required': 'Password is required',
  'E-mail is required': 'E-mail is required',
  'E-mail must be valid': 'E-mail must be valid',
  'Scan QR code to download the app': 'Scan QR code to download the app',
  // Set Password
  'Update': 'Update',
  'Set': 'Set',
  'Reset': 'Reset',
  'New Password': 'New Password',
  'Confirm Password': 'Confirm Password',
  'Show password': 'Show password',
  'Submit': 'Submit',
  'Skip': 'Skip',
  'Back': 'Back',
  'Resend email after 10 mins': 'Resend email after {min} minutes',
  'Must have atleast 8 characeters': 'Must have atleast 8 characeters',
  'Its better to have': 'Its better to have',
  'Upper & lower case letters': 'Upper & lower case letters',
  'A symbol (#&$)': 'A symbol (#&$)',
  'A numerical value (0-9)': 'A numerical value (0-9)',
  'The longer the password, the better': 'The longer the password, the better',
  // 403 Page
  'Access Denied': 'Access Denied',
  'sorry, but you don\'t have permission to access this page.': 'sorry, but you don\'t have permission to access this page.',
  'You can go back to': 'You can go back to',
  // Navigation
  'Last Update': 'Last Update',
  'Home': 'Home',
  'Plant Overview': 'Plant Overview',
  'Devices': 'Devices',
  'Alert': 'Alert',
  'Services': 'Services',
  'Support': 'Support',
  'Logout': 'Logout',
  'Admin': 'Admin',
  'For further queries contact': 'For further queries contact',
  // Tool Bar
  'Notification': 'Notification',
  'View more': 'View more',
  'Theme': 'Theme',
  'Auto-Refresh - Every': 'Auto-Refresh - Every',
  'Last Updated': 'Last Updated',
  'Single Click - Toggle Auto Reload': 'Single Click - Toggle Auto Reload',
  'Double Click - Instant Refresh': 'Double Click - Instant Refresh',
  'Fullscreen': 'Fullscreen',
  'Select Language': 'Select Language',
  'Grid': 'Grid',
  'Inverter': 'Inverter',
  // Dashboard change toolbar
  'Dashboard': 'Dashboard',
  // FILTER
  'APPLY': 'APPLY',
  'Filter': 'Filter',
  'Select Date': 'Select Date',
  'Start Date': 'Start Date',
  'End Date': 'End Date',
  'Pick Date': 'Pick Date',
  'Select All': 'Select All',
  'Deselect All': 'Deselect All',
  'Select device type': 'Select device type',
  'Choose Date Range': 'Choose Date Range',
  'Select Date Range': 'Select Date Range',
  'Last 3 days': 'Last 3 days',
  'Last 7 days': 'Last 7 days',
  'Last 30 days': 'Last 30 days',
  'Present month': 'Present month',
  'Last month': 'Last month',
  'Last 3 months': 'Last 3 months',
  'Present Year': 'Present Year',
  'Last year': 'Last year',
  'Last Year': 'Last Year',
  'Custom': 'Custom',
  'Severity': 'Severity',
  'Critical': 'Critical',
  'High': 'High',
  'Medium': 'Medium',
  'Low': 'Low',
  'Warning': 'Warning',
  'Info': 'Info',
  'Select an Interval': 'Select an Interval',
  'Select Time Range': 'Select Time Range',
  'Use time range': 'Use time range',
  'Select Date Format': 'Select Date Format',
  'Select WS': 'Select WS',
  'Select Inverters': 'Select Inverters',
  'Select Trackers': 'Select Trackers',
  'hourly': 'hourly',
  '30 mins': '30 mins',
  '15 mins': '15 mins',
  '10 mins': '10 mins',
  '5 mins': '5 mins',
  '1 mins': '1 mins',
  // HOME
  'Subscription Alert': 'Subscription Alert',
  'TOTAL PLANTS': 'TOTAL PLANTS',
  'AC CAPACITY': 'AC CAPACITY',
  'DC CAPACITY': 'DC CAPACITY',
  'ENERGY TODAY': 'ENERGY TODAY',
  'Daily Updates': 'Daily Updates',
  'Search': 'Search',
  'NAME': 'NAME',
  'Name': 'Name',
  'LOCATION': 'LOCATION',
  'GEN(kWh)': 'GEN(kWh)',
  'home PR(%)': 'PR(%)',
  'STATUS': 'STATUS',
  'New Alerts': 'New Alerts',
  'No Alerts': 'No Alerts',
  'MAP View': 'MAP View',
  'Carbon Footprint(Today)': 'Carbon Footprint(Today)',
  'CARBON FOOTPRINT (TODAY)': 'CARBON FOOTPRINT (TODAY)',
  'CARBON FOOTPRINT': 'CARBON FOOTPRINT',
  'Tree Saplings Planted': 'Tree Saplings Planted',
  'House Lighted': 'House Lighted',
  'Diesel Consumption Reduced': 'Diesel Consumption Reduced',
  'CO2 emission Reduced': 'CO2 emission Reduced',
  // PlantOverview
  'Static Plant Info': 'Static Plant Info',
  'Bulletin': 'Bulletin',
  'NO DATA': 'NO DATA',
  'No Data': 'No Data',
  'No data': 'No Data',
  'no data': 'No Data',
  'Plant Details': 'Plant Details',
  'Yet To Compute': 'Yet To Compute',
  'Not Available': 'Not Available',
  'INV Gen (Today)': 'INV Gen (Today)',
  'Lifetime Generation (kWh)': 'Lifetime Generation (kWh)',
  'Monthly Revenue': 'Monthly Revenue',
  'Daily Revenue': 'Daily Revenue',
  'INV Gen (Yesterday)': 'INV Gen (Yesterday)',
  'INV Gen (MTD)': 'INV Gen (MTD)',
  'INV Gen (YTD)': 'INV Gen (YTD)',
  'INV Gen (ITD)': 'INV Gen (ITD)',
  'AC Capacity': 'AC Capacity',
  'DC Capacity': 'DC Capacity',
  'Data Logger Status': 'Data Logger Status',
  'Live Temp': 'Live Temp',
  'AC Power (INV)': 'AC Power (INV)',
  'Block CUF': 'Block CUF',
  'DC Power (INV)': 'DC Power (INV)',
  'AC Yield (INV)': 'AC Yield (INV)',
  'Peak Power (INV)': 'Peak Power (INV)',
  'CUF (INV)': 'CUF (INV)',
  'MFM Gen (Today)': 'MFM Gen (Today)',
  'MFM Gen (Yesterday)': 'MFM Gen (Yesterday)',
  'MFM Gen (MTD)': 'MFM Gen (MTD)',
  'MFM Gen (YTD)': 'MFM Gen (YTD)',
  'MFM Gen (FTD)': 'MFM Gen (FTD)',
  'Efficiency': 'Efficiency',
  'Peak Power (MFM)': 'Peak Power (MFM)',
  'AC Yield (MFM)': 'AC Yield (MFM)',
  'EM Gen (Today)': 'EM Gen (Today)',
  'EM Gen (Yesterday)': 'EM Gen (Yesterday)',
  'EM Gen (MTD)': 'EM Gen (MTD)',
  'EM Gen (YTD)': 'EM Gen (YTD)',
  'Radiation Insolation': 'Radiation Insolation',
  'AC Power (EM)': 'AC Power (EM)',
  'AC Yield (EM)': 'AC Yield (EM)',
  'CUF (EM)': 'CUF (EM)',
  'EM Gen (FTD)': 'EM Gen (FTD)',
  'Peak Power (EM)': 'Peak Power (EM)',
  'AC Power (MFM)': 'AC Power (MFM)',
  'Plant AC Yield': 'Plant AC Yield',
  'Inv Start': 'Inv Start',
  'Inv Stop': 'Inv Stop',
  'Inst. PA (%)': 'Inst. PA (%)',
  'Grid Status': 'Grid Status',
  'Plant Availability': 'Plant Availability',
  'Grid Availability': 'Grid Availability',
  'Map View': 'Map View',
  'INV ROOM': 'INV ROOM',
  'INV': 'INV',
  'generation': 'Generation',
  'pr': 'PR',
  'cuf': 'CUF',
  'PR INV': 'PR INV',
  'EM PR': 'EM PR',
  'MFM PR': 'MFM PR',
  // INVERTER DB
  'Dip Reason': 'Dip Reason',
  'NO ALERTS': 'NO ALERTS',
  'Created Time': 'Created Time',
  'Resolved Time': 'Resolved Time',
  'Created time': 'Created time',
  'Resolved time': 'Resolved time',
  'Block List': 'Block List',
  'Total Inv Gen': 'Total Inv Gen',
  'Generation Graph': 'Generation Graph',
  'Power Graph': 'Power Graph',
  'Plant Total Graph': 'Plant Total Graph',
  'Plant Total': 'Plant Total',
  'Energy': 'Energy',
  'Power': 'Power',
  'Current': 'Current',
  'Select Graph': 'Select Graph',
  'Graph Type': 'Graph Type',
  'Total': 'Total',
  'Yield': 'Yield',
  'Inverter Wise': 'Inverter Wise',
  'Generation (kWh)': 'Generation (kWh)',
  'Irradiance (W/m²)': 'Irradiance (W/m²)',
  // MFM DB
  'MFM List': 'MFM List',
  'Export (kWh)': 'Export (kWh)',
  'AC Power (KW)': 'AC Power (KW)',
  // MFM Graph
  'R Phase(V)': 'R Phase(V)',
  'B Phase(V)': 'B Phase(V)',
  'YB-line(V)': 'YB-line(V)',
  'Current R(A)': 'Current R(A)',
  'Current B(A)': 'Current B(A)',
  'AC Power(kw)': 'AC Power(kw)',
  'Export(kWh)': 'Export(kWh)',
  'Temperature(c)': 'Temperature(c)',
  'Y Phase(V)': 'Y Phase(V)',
  'RY-line(V)': 'RY-line(V)',
  'BR-line(V)': 'BR-line(V)',
  'Current Y(A)': 'Current Y(A)',
  'Frequency(Hz)': 'Frequency(Hz)',
  'Import(kWh)': 'Import(kWh)',
  'Reactive Power(kVAR)': 'Reactive Power(kVAR)',
  // Weather Station
  'Graph': 'Graph',
  'Table': 'Table',
  // Weather Station Header
  'Module Temperature': 'Module Temperature',
  'Ambient Temperature': 'Ambient Temperature',
  'GHI': 'GHI',
  'PoA': 'PoA',
  'Humidity': 'Humidity',
  'Wind Direction': 'Wind Direction',
  'LIVE': 'LIVE',
  'MIN': 'MIN',
  'MAX': 'MAX',
  'AVG': 'AVG',
  'LAST PACKET': 'LAST PACKET',
  'CUMULATIVE': 'CUMULATIVE',
  // Weather Station Graph
  'Irradiance PoA': 'Irradiance PoA',
  'Irradiance GHI': 'Irradiance GHI',
  'Radiation': 'Radiation',
  'Pressure': 'Pressure',
  // TRACKER
  'Accuracy (%)': 'Accuracy (%)',
  'Operation Mode': 'Operation Mode',
  // ADVANCED SCB
  // SCB Table
  'Ch Ref Id': 'Ch Ref Id',
  'Channel Ref. Id for Underperforming String': 'Channel Ref. Id for Underperforming String',
  'Select All Channels': 'Select All Channels',
  'Total Current': 'Total Current',
  'Voltage': 'Voltage',
  'Temp': 'Temp',
  'DC Power': 'DC Power',
  'Breaker Status': 'Breaker Status',
  'SPD Status': 'SPD Status',
  'ON': 'ON',
  'OFF': 'OFF',
  'Intact': 'Intact',
  'Blown': 'Blown',
  // ZMU
  'Multiplication Factor': 'Multiplication Factor',
  'Total Power': 'Total Power',
  // STRING INVERTER
  'Please select String Inverters in order to check the graph': 'Please select String Inverters in order to check the graph',
  'Please select the channels in order to check graph': 'Please select the channels in order to check graph',
  'Equipment': 'Equipment',
  'Voltage(V)': 'Voltage(V)',
  'Power(kW)': 'Power(kW)',
  'Temperature(°C)': 'Temperature(°C)',
  // ADVANCED STRING INVERTER
  'Total Power (kW)': 'Total Power (kW)',
  // ZONE MONITORING
  'Channel': 'Channel',
  'Equipment [Block / Room / Device Name]': 'Equipment [Block / Room / Device Name]',
  // LIVE DASHBOARD
  'Live Data': 'Live Data',
  'MFM Name': 'MFM Name',
  'Export(kWh)': 'Export(kWh)',
  'Import(kWh)': 'Import(kWh)',
  'INV Name': 'INV Name',
  'Generation (kWh)': 'Generation (kWh)',
  'AC Yield (Inverter)': 'AC Yield (Inverter)',
  'CUF (Inverter)': 'CUF (Inverter)',
  'CUF (MFM)': 'CUF (MFM)',
  'EM Name': 'EM Name',
  'SCB Name': 'SCB Name',
  // ALERT
  'Alert': 'Alert',
  'Equipments': 'Equipments',
  'Alert Details': 'Alert Details',
  'New': 'New',
  'Acknowledge': 'Acknowledge',
  'Resolved': 'Resolved',
  'ASC': 'ASC',
  'DESC': 'DESC',
  'Status': 'Status',
  'Code': 'Code',
  'Manual Alert': 'Manual Alert',
  'communication': 'communication',
  'Grid Failure': 'Grid Failure',
  'Network Failure': 'Network Failure',
  'Grid Failure/Network Failure': 'Grid Failure/Network Failure',
  'VCB \'Breaker Name\' Failure': 'VCB \'Breaker Name\' Failure',
  'INV Not Started/Failure': 'INV Not Started/Failure',
  'SCB Failure': 'SCB Failure',
  'PoA_Value: Out of Range': 'PoA_Value: Out of Range',
  'GHI_Value: Out of Range': 'GHI_Value: Out of Range',
  'Ambient Temperature: Out of Range': 'Ambient Temperature: Out of Range',
  'Module Temperature: Out of Range': 'Module Temperature: Out of Range',
  'Wind Direction : Out of Range': 'Wind Direction: Out of Range',
  'Communication Failure': 'Communication Failure',
  'Grid/Communication Failure': 'Grid/Communication Failure',
  'Start Time': 'Start Time',
  'Message': 'Message',
  'Alert Message': 'Alert Message',
  'computed': 'computed',
  'Device': 'Device',
  'Resolve': 'Resolve',
  'Time': 'Time',
  'Updated by': 'Updated by',
  'Added by': 'Added by',
  'Stats': 'Stats',
  // DOWN TIME ANALYSIS
  'DOWN TIME': 'DOWN TIME',
  'Down Time': 'Down Time',
  'DOWN ENERGY': 'DOWN ENERGY',
  'Energy Loss': 'Energy Loss',
  'GRAPH': 'GRAPH',
  'Not Down': 'Not Down',
  'Loss': 'Loss',
  'Date': 'Date',
  'State': 'State',
  'Calculated Energy loss when Solar PV plant is not generating power due to technical failures (Grid/Inverter). This Energy is calculated based on the irradiance value and inverter capacity': 
  `Calculated Energy loss when Solar PV plant is not generating power due to technical failures (Grid/Inverter). 
  This Energy is calculated based on the irradiance value and inverter capacity`,
  'Time when the PV system cannot provide power to the load, downtime may be due to technical failure of the solar plant or maintenance of the solar plant.': 
  `Time when the PV system cannot provide power to the load, downtime may be due to technical failure of the solar plant or maintenance of the solar plant.`,
  // FORECAST
  'Next hour forecast': 'Next hour forecast',
  'Irradiance': 'Irradiance',
  'Generation Data': 'Generation Data',
  'Data upto previous hour': 'Data upto previous hour',
  'Actual Gen': 'Actual Gen',
  'Forecasted Gen': 'Forecasted Gen',
  'Penalty Trend': 'Penalty Trend',
  'Trend compared upto previous hour': 'Trend compared upto previous hour',
  'Today': 'Today',
  'Yesterday': 'Yesterday',
  'Trend': 'Trend',
  'Actual Data vs Forecasted Data': 'Actual Data vs Forecasted Data',
  'Data comparision for actual generation vs forecasted generation': 'Data comparision for actual generation vs forecasted generation',
  'Deviation': 'Deviation',
  'Revision': 'Revision',
  'Trend Table': 'Trend Table',
  'Generation/weather parameters trend': 'Generation/weather parameters trend',
  'Actual': 'Actual',
  'Forecast': 'Forecast',
  'Range and Deviation': 'Range and Deviation',
  'Trend': 'Trend',
  'Generation vs Penalty': 'Generation vs Penalty',
  'Data compared to deviation range': 'Data compared to deviation range',
  'Range': 'Range',
  'Penalty': 'Penalty',
  'Previous Revision Id': 'Previous Revision Id',
  'Forecast Generation (MWh)': 'Forecast Generation (MWh)',
  'sunny': 'Sunny',
  'mostly sunny': 'Mostly Sunny',
  'partly sunny': 'Partly Sunny',
  'intermittent clouds': 'Intermittent Clouds',
  'hazy sunshine': 'Hazy Sunshine',
  'mostly cloudy': 'Mostly Cloudy',
  'cloudy': 'Cloudy',
  'dreary (overcast)': 'Dreary (Overcast)',
  'fog': 'Fog',
  'showers': 'Showers',
  'mostly cloudy w/ showers': 'Mostly Cloudy w/ Showers',
  'partly sunny w/ showers': 'Partly Sunny w/ Showers',
  't-storms': 'T-Storms',
  'mostly cloudy w/ t-storms': 'Mostly Cloudy w/ T-Storms',
  'partly sunny w/ t-storms': 'Partly Sunny w/ T-Storms',
  'rain': 'Rain',
  'flurries': 'Flurries',
  'mostly cloudy w/ flurries': 'Mostly Cloudy w/ Flurries',
  'partly sunny w/ flurries': 'Partly Sunny w/ Flurries',
  'snow': 'Snow',
  'mostly cloudy w/ snow': 'Mostly Cloudy w/ Snow',
  'ice': 'Ice',
  'sleet': 'Sleet',
  'freezing rain': 'Freezing Rain',
  'rain and snow': 'Rain and Snow',
  'hot': 'Hot',
  'cold': 'Cold',
  'windy': 'Windy',
  'clear': 'Clear',
  'mostly clear': 'Mostly Clear',
  'partly cloudy': 'Partly Cloudy',
  'hazy moonlight': 'Hazy Moonlight',
  'partly cloudy w/ showers': 'Partly Cloudy w/ Showers',
  'partly cloudy w/ t-Storms': 'Partly Cloudy w/ T-Storms',
  // OTHER SENSOR
  'SHOW DETAILS': 'SHOW DETAILS',
  'Block': 'Block',
  'Inverter Room': 'Inverter Room',
  'Sensor Time': 'Sensor Time',
  'Sensor Reading Time': 'Sensor Reading Time',
  'Import Cumulative (kWh)': 'Import Cumulative (kWh)',
  'Export Cumulative (kWh)': 'Export Cumulative (kWh)',
  'Total Import (kWh)': 'Total Import (kWh)',
  'Total Export (kWh)': 'Total Export (kWh)',
  'R-Phase (kV)': 'R-Phase (kV)',
  'Y-Phase (kV)': 'Y-Phase (kV)',
  'B-Phase (kV)': 'B-Phase (kV)',
  'Frequency (Hz)': 'Frequency (Hz)',
  'L1 (A)': 'L1 (A)',
  'L2 (A)': 'L2 (A)',
  'L3 (A)': 'L3 (A)',
  'Daily Import (kWh)': 'Daily Import (kWh)',
  'Daily Export (kWh)': 'Daily Export (kWh)',
  'AC Power (kW)': 'AC Power (kW)',
  'Peak Power (kW)': 'Peak Power (kW)',
  'Reactive Power (kW)': 'Reactive Power (kW)',
  'Soiling Ratio 1 (%)': 'Soiling Ratio 1 (%)',
  'Soiling Ratio 2 (%)': 'Soiling Ratio 2 (%)',
  'Transmit Loss 1 (%)': 'Transmit Loss 1 (%)',
  'Transmit Loss 2 (%)': 'Transmit Loss 2 (%)',
  'Ref Module Temp(°C)': 'Ref Module Temp(°C)',
  'Test Module Temp(°C)': 'Test Module Temp(°C)',
  'SR Daily Avg(%)': 'SR Daily Avg(%)',
  'SP Daily Avg(%)': 'SP Daily Avg(%)',
  'Geff Ref(W/m²)': 'Geff Ref(W/m²)',
  'Geff Test(W/m²)': 'Geff Test(W/m²)',
  'ISC Ref(A)': 'ISC Ref(A)',
  'ISC Test(A)': 'ISC Test(A)',
  'Soil Ratio(%)': 'Soil Ratio(%)',
  'Soil Percentage(%)': 'Soil Percentage(%)',
  'AC output voltage (V)': 'AC output voltage (V)',
  'AC input voltage (V)': 'AC input voltage (V)',
  'Battery Voltage (V)': 'Battery Voltage (V)',
  'Current Load (kW)': 'Current Load (kW)',
  'Invalid Voltage(V)': 'Invalid Voltage(V)',
  'Battery Temperature(°C)': 'Battery Temperature(°C)',
  'Actual OT (°C)': 'Actual OT (°C)',
  'Actual WT (°C)': 'Actual WT (°C)',
  'Max OT (°C)': 'Max OT (°C)',
  'Max WT (°C)': 'Max WT (°C)',
  'OT Alarm Set (°C)': 'OT Alarm Set (°C)',
  'OT Trip Set (°C)': 'OT Trip Set (°C)',
  'WT Alarm Set (°C)': 'WT Alarm Set (°C)',
  'WT Trip Set (°C)': 'WT Trip Set (°C)',
  'Tracker Angle': 'Tracker Angle',
  'Actual Angle': 'Actual Angle',
  'Input Voltage': 'Input Voltage',
  'Deviation Angle': 'Deviation Angle',
  'Mode Status': 'Mode Status',
  'Wind Speed': 'Wind Speed',
  'Error Status': 'Error Status',
  'Breaker ON': 'Breaker ON',
  'Breaker OFF': 'Breaker OFF',
  'Breaker Trip': 'Breaker Trip',
  'Local': 'Local',
  'Remote': 'Remote',
  'Test': 'Test',
  'Spring Charge': 'Spring Charge',
  'Trip Circuit': 'Trip Circuit',
  'DC Supply': 'DC Supply',
  // INVERTER RANKING
  'Overall Performance': 'Overall Performance',
  'Overall performance info': 'Overall performance info',
  'Overall performance of inverter is derived from individual ranking buckets. Lower the points(pts) will be considered as higher in performance.': 'Overall performance of inverter is derived from individual ranking buckets. Lower the points(pts) will be considered as higher in performance.',
  'Ranking Trends': 'Ranking Trends',
  'Present Month': 'Present Month',
  'Last Month': 'Last Month',
  'up': 'up',
  'down': 'down',
  'Best': 'Best',
  'Least': 'Least',
  'others': 'others',
  'Other best inv': 'Other best inv',
  'Other least inv': 'Other least inv',
  'Best Performing Inverter': 'Best Performing Inverter',
  'trend compared to prior month\'s PR': 'trend compared to prior month\'s PR',
  'Highest ranked Inverters': 'Highest ranked Inverters',
  'Best inverters': 'Best inverters',
  'Present & Last month': 'Present & Last month',
  'PRESENT': 'PRESENT',
  'LAST': 'LAST',
  'Trend compared to prior month (%)': 'Trend compared to prior month (%)',
  'Current month\'s PR (%)': 'Current month\'s PR (%)',
  'Prior month\'s PR (%)': 'Prior month\'s PR (%)',
  'PR\'S NOT CONFIGURED': 'PR\'S NOT CONFIGURED',
  'Inverter Ranking based on': 'Inverter Ranking based on',
  'sorted in descending order': 'sorted in descending order',
  'Performance Summary': 'Performance Summary',
  'Performance info': 'Performance info',
  'viewing based on': 'viewing based on',
  'Overall Performance based on': 'Overall Performance based on',
  'Data Table': 'Data Table',
  'Aggregate values for all parameters': 'Aggregate values for all parameters',
  'Heat Map': 'Heat Map',
  'Inverter data visualization vs parameters': 'Inverter data visualization vs parameters',
  'Down Time(min)': 'Down Time(min)',
  'Down\nTime Energy(kWh)': 'Down Time Energy(kWh)',
  'AC Yield(kW)': 'AC Yield(kW)',
  'Efficiency(%)': 'Efficiency(%)',
  'Above 80': 'Above 80',
  'Between 75 & 80': 'Between 75 & 80',
  'Below 75': 'Below 75',
  'Above 98': 'Above 98',
  'Between 90 & 98': 'Between 90 & 98',
  'Below 90': 'Below 90',
  'Generation above "4*INV DC Capacity)"': 'Generation above "4*INV DC Capacity)"',
  'Above 4': 'Above 4',
  'Between 3.5 & 4': 'Between 3.5 & 4',
  'Below 3.5': 'Below 3.5',
  'Below 10 min': 'Below 10 min',
  'Between 10min & 15min': 'Between 10min & 15min',
  'More than 15min': 'More than 15min',
  'Below 60': 'Below 60',
  'Between 60 & 100': 'Between 60 & 100',
  'More than 100': 'More than 100',
  'Total Points': 'Total Points',
  // SLD
  'Value 0': 'Value 0',
  'Any value 1': 'Any value 1',
  'IN/OUT TAG': 'IN/OUT TAG',
  'Change View to': 'Change View to',
  'Input': 'Input',
  'Output': 'Output',
  'Value': 'Value',
  // CUSTOM REPORT
  'Fetching Report': 'Fetching Report',
  'REPORTS': 'REPORTS',
  'No template configured': 'No template configured',
  'Plant Level': 'Plant Level',
  'Block Level': 'Block Level',
  'Device Level': 'Device Level',
  'INV Level Gen': 'INV Level Gen',
  ' INV Gen': 'INV Gen',
  'EM Level Gen': 'EM Level Gen',
  ' EM Gen': 'EM Gen',
  'MFM Level Gen': 'MFM Level Gen',
  ' Performance Report': 'Performance Report',
  ' Summary Report': 'Summary Report',
  ' Device Report': 'Device Report',
  'Inverter level generation report': 'Inverter level generation report',
  'Plant level inverter generation report': 'Plant level inverter generation report',
  'Block level inverter generation': 'Block level inverter generation',
  'Energy meter level generation report': 'Energy meter level generation report',
  'MFM level generation report': 'MFM level generation report',
  'Plant level energy meter generation report': 'Plant level energy meter generation report',
  'Device Level Performance Report': 'Device Level Performance Report',
  'Plant Summary Report': 'Plant Summary Report',
  'Block Level Device Report': 'Block Level Device Report',
  'GRAPHICAL REPORTS': 'GRAPHICAL REPORTS',
  'TABULAR REPORTS': 'TABULAR REPORTS',
  'POA Insolation (kWh/m²)': 'POA Insolation (kWh/m²)',
  'INV GEN (kWh)': 'INV GEN (kWh)',
  'POA (W/m²)': 'POA (W/m²)',
  // PLANT ANALYTICS
  'SAVE TEMPLATE': 'SAVE TEMPLATE',
  'Plant Analogue': 'Plant Analogue',
  'Plant KPI\'s': 'Plant KPI\'s',
  'Select Plants/Devices': 'Select Plants/Devices',
  'Select Parameters': 'Select Parameters',
  'KPI\'s are inverter based': 'KPI\'s are inverter based',
  'RETRIEVE': 'RETRIEVE',
  'Retrieve the Saved Templates': 'Retrieve the Saved Templates',
  'Plot Graph/Table': 'Plot Graph/Table',
  'VIEW': 'VIEW',
  'Save As Template': 'Save As Template',
  'Select Options in order to check data at Plant Level or Device Level': 'Select Options in order to check data at Plant Level or Device Level',
  'Are you sure, you wanna delete this template': 'Are you sure, you wanna delete this template',
  'You can only save upto 5 Templates max.Please remove one of the Pre-saved Template, in order to proceed.': 'You can only save upto 5 Templates max.Please remove one of the Pre-saved Template, in order to proceed.',
  'Please Select Parameters': 'Please Select Parameters',
  'Template Saved Successfully': 'Template Saved Successfully',
  'Failed to save template!': 'Failed to save template!',
  'Template Deleted Successfully': 'Template Deleted Successfully',
  'Failed to delete template!': 'Failed to delete template!',
  'Please Select Plant/Parameters': 'Please Select Plant/Parameters',
  'Refresh': 'Refresh',
  'Download Image': 'Download Image',
  'Download CSV': 'Download CSV',
  'Enter Template Name': 'Enter Template Name',
  'Search Plant': 'Search Plant',
  'Search Device': 'Search Device',
  // INVERTER CONTROL
  'CONTROL': 'CONTROL',
  'CHANGE INVERTER STATE': 'CHANGE INVERTER STATE',
  'Change inverter state': 'Change inverter state',
  'CHANGE SELECTED INVERTER STATE': 'CHANGE SELECTED INVERTER STATE',
  'Are you sure to change': 'Are you sure to change',
  'Sorry Connection Lost with Device': 'Sorry Connection Lost with Device',
  'Updated Successfully': 'Updated Successfully',
  'Failed! Retry again': 'Failed! Retry again',
  'Username or password entered is incorrect': 'Username or password entered is incorrect',
  'Enter the Password': 'Enter the Password',
  'Email': 'Email',
  'Password': 'Password',
  'Reject': 'Reject',
  'Please Enter Power Factor Value Between': 'Please Enter Power Factor Value Between',
  'Please enter an interger': 'Please enter an interger',
  'Please Enter Active Power Value Between': 'Please Enter Active Power Value Between',
  'Please Enter Reactive Power Value Between': 'Please Enter Reactive Power Value Between',
  'Are You Sure To Change': 'Are You Sure To Change',
  'Are you sure you want to change the state': 'Are you sure you want to change the state',
  'Connected': 'Connected',
  'Connection Lost': 'Connection Lost',
  'Current status of': 'Current status of',
  'is': 'is',
  'is currently': 'is currently',
  'POWER FACTOR': 'POWER FACTOR',
  'REACTIVE POWER': 'REACTIVE POWER',
  'ACTIVE POWER': 'ACTIVE POWER',
  // Archive
  'Archive': 'Archive',
  'Data is available per week': 'Data is available per week',
  'Archive Content': 'Archive Content',
  'Reset': 'Reset',
  'File': 'File',
  'Date From': 'Date From',
  'Date To': 'Date To',
  'Actions': 'Actions',
  'Rows per page:': 'Rows per page:',
  // String Evaluation
  'String Evaluation': 'String Evaluation',
  'Ref String': 'Ref String',
  'Ref Value': 'Ref Value',
  'Channel': 'Channel',
  'Current (A)': 'Current (A)',
  'Deviation (%)': 'Deviation (%)',
  'Evaluation': 'Evaluation',
  // THINK HOME
  'DATA LOGGERS': 'DATA LOGGERS',
  'Performance Ratio': 'Performance Ratio',
  'DC CAPACITY': 'DC CAPACITY',
  'ENERGY TODAY': 'ENERGY TODAY',
  'Monthly PR': 'Monthly PR',
  'Annual PR': 'Annual PR',
  'Monthly CUF': 'Monthly CUF',
  'Annual CUF': 'Annual CUF',
  'City': 'City',
  'Yield (kWh/kWp)': 'Yield (kWh/kWp)',
  'Insolation': 'Insolation',
  'PR (%)': 'PR (%)',
  'Refresh': 'Refresh',
  'Download CSV': 'Download CSV',
  'Your search for': 'Your search for',
  'found no results': 'found no results',
  'Plant Alerts': 'Plant Alerts',
  'Download': 'Download',
  'Select an alert': 'Select an alert',
  'Please select an option': 'Please select an option',
  'There was some error while loading the data. Please try again!!': 'There was some error while loading the data. Please try again!!',
  // REPORT
  'Select Interval': 'Select Interval',
  'Select Device': 'Select Device',
  'Select INV ROOM': 'Select INV ROOM',
  'Select Block': 'Select Block',
  'Selected date exceeds 30 day': 'Selected date exceeds 30 day',
  'No Data for Specific Date\'s': 'No Data for Specific Date\'s',
  'No Data Available': 'No Data Available',
  'Cannot download data more than 15 days': 'Cannot download data more than 15 days',
  'Cannot download data more than a month': 'Cannot download data more than a month',
  'Cannot Download data beyond 180 days': 'Cannot Download data beyond 180 days',
  'Please Select an interval': 'Please Select an interval',
  'Please Select valid parameters': 'Please Select valid parameters',
  'Please Select a Device': 'Please Select a Device',
  'Device Name': 'Device Name',
  // Legend text
  'Known Issue': 'Known Issue',
  'Under Performing': 'Under Performing',
  'String Underperforming': 'String Underperforming',
  'Comm Error': 'Comm Error',
  'NC': 'NC',
  'Selected': 'Selected',
  // COMMON TERMINOLOGY
  'Show Graph': 'Show Graph',
  'Show Table': 'Show Table',
  'Selected Items': 'Selected Items',
  'Clear Selection': 'Clear Selection',
  'Clear All': 'Clear All',
  'Live': 'Live',
  'Average': 'Average',
  'Avg': 'Avg',
  'Computed': 'Computed',
  'Raw': 'Raw',
  'Note': 'Note',
  'Not Connected': 'Not Connected',
  'Click to make it stick': 'Click to make it stick',
  'Cancel': 'Cancel',
  'Send': 'Send',
  'UP': 'UP',
  'DOWN': 'DOWN',
  'Reason': 'Reason',
  'Remarks': 'Remarks',
  'Parameters': 'Parameters',
  'Any Comments': 'Any Comments',
  'NO': 'NO',
  'YES': 'YES',
  'Yes': 'Yes',
  'select': 'select',
  'Select': 'Select',
  // COMMON HEADER
  'EM Generation': 'EM Generation',
  'Generation': 'Generation',
  'PR': 'PR',
  'GHI Insolation': 'GHI Insolation',
  'Wind Speed': 'Wind Speed',
  'Temperature': 'Temperature',
  'PoA Insolation': 'PoA Insolation',
  'Loading': 'Loading',
  'Indicates required field': 'Indicates required field',
  'This field is required': 'This field is required',
  'SUBMIT': 'SUBMIT',
  'N/A': 'N/A',
  'n/a': 'N/A',
  'Close': 'Close',
  'Hey, Wait': 'Hey, Wait',
  'Disagree': 'Disagree',
  'Agree': 'Agree',
  'CANCEL': 'CANCEL',
  'SAVE': 'SAVE',
  // Progress Bar
  'Please Wait': 'Please Wait',
  'Loading': 'Loading',
  // GLOBAL PARAMETERS
  // Devices
  'Annunciator': 'Annunciator',
  'annunciator': 'annunciator',
  'EM': 'EM',
  'Energy Meter': 'Energy Meter',
  'energy meter': 'energy meter',
  'MFM': 'MFM',
  'mfm': 'MFM',
  'SCB': 'SCB',
  'scb': 'SCB',
  'Weather Station': 'Weather Station',
  'weather station': 'Weather Station',
  'ZMU': 'ZMU',
  'zmu': 'zmu',
  'MPPT': 'MPPT', 
  'mppt': 'mppt', 
  'Relay': 'Relay',
  'relay': 'relay',
  'Soil Sensor': 'Soil Sensor',
  'soil sensor': 'soil sensor',
  'Tracker': 'Tracker',
  'tracker': 'Tracker',
  'Transformer': 'Transformer',
  'transformer': 'transformer',
  'UPS': 'UPS',
  'ups': 'UPS',
  'Grid': 'Grid',
  'grid': 'Grid',
  'Inverter': 'Inverter',
  'inverter': 'Inverter',
  'Gateway Comm.': 'Gateway Comm.',
  'Breaker': 'Breaker',
  'breaker': 'breaker',
  'Computed.': 'Computed.',
  'gateway': 'gateway',
  'computed': 'computed',
  // ANNUNCIATOR
  'Device ID': 'Device ID',
  'Molg Alarm': 'Molg Alarm',
  'OC EF Trip': 'OC EF Trip',
  'UV OV Trip': 'UV OV Trip',
  'Master Trip': 'Master Trip',
  'TF OTI Trip': 'TF OTI Trip',
  'TF WTI Trip': 'TF WTI Trip',
  'TF OTI Alarm': 'TF OTI Alarm',
  'TF WTI Alarm': 'TF WTI Alarm',
  'TF Bchlz Trip': 'TF Bchlz Trip',
  'TF Bchlz Alarm': 'TF Bchlz Alarm',
  // BREAKER
  'Local': 'Local',
  'Remote': 'Remote',
  'Trip Circuit Healthy': 'Trip Circuit Healthy',
  'DC Supply': 'DC Supply',
  'Breaker On': 'Breaker On',
  'Breaker OFF': 'Breaker OFF',
  'Breaker Trip': 'Breaker Trip',
  'Spring Charge': 'Spring Charge',
  // ENERGY METER
  'GA (%)': 'GA (%)',
  'PA (%)': 'PA (%)',
  'PR (%)': 'PR (%)',
  'R-Phase (V)': 'R-Phase (V)',
  'Y-Phase (V)': 'Y-Phase (V)',
  'B-Phase (V)': 'B-Phase (V)',
  'Line Current 12 (A)': 'Line Current 12 (A)',
  'Line Current 23 (A)': 'Line Current 23 (A)',
  'Line Current 31 (A)': 'Line Current 31 (A)',
  'CUF (%)': 'CUF (%)',
  'RY-Line (V)': 'RY-Line (V)',
  'YB-Line (V)': 'YB-Line (V)',
  'BR-Line (V)': 'BR-Line (V)',
  'R-Phase-Thd (V)': 'R-Phase-Thd (V)',
  'Y-Phase-Thd (V)': 'Y-Phase-Thd (V)',
  'B-Phase-Thd (V)': 'B-Phase-Thd (V)',
  'AC Power (kW)': 'AC Power (kW)',
  'AC Yield (kW)': 'AC Yield (kW)',
  'Frequency (Hz)': 'Frequency (Hz)',
  'AC Power L1 (kW)': 'AC Power L1 (kW)',
  'AC Power L2 (kW)': 'AC Power L2 (kW)',
  'AC Power L3 (kW)': 'AC Power L3 (kW)',
  'Temperature (°C)': 'Temperature (°C)',
  'Power Factor (kW)': 'Power Factor (kW)',
  'Apparent Power (kW)': 'Apparent Power (kW)',
  'Apparent Power 1 (kW)': 'Apparent Power 1 (kW)',
  'Apparent Power 2 (kW)': 'Apparent Power 2 (kW)',
  'Apparent Power 3 (kW)': 'Apparent Power 3 (kW)',
  'R-Phase (A)': 'R-Phase (A)',
  'Y-Phase (A)': 'Y-Phase (A)',
  'B-Phase (A)': 'B-Phase (A)',
  'Power Factor': 'Power Factor',
  'Power Factor 1 (kW)': 'Power Factor 1 (kW)',
  'Power Factor 2 (kW)': 'Power Factor 2 (kW)',
  'Power Factor 3 (kW)': 'Power Factor 3 (kW)',
  'Reactive Power (kVAR)': 'Reactive Power (kVAR)',
  'Reactive Power 1 (kW)': 'Reactive Power 1 (kW)',
  'Reactive Power 2 (kW)': 'Reactive Power 2 (kW)',
  'Reactive Power 3 (kW)': 'Reactive Power 3 (kW)',
  'R-Phase-Thd (A)': 'R-Phase-Thd (A)',
  'Y-Phase-Thd (A)': 'Y-Phase-Thd (A)',
  'B-Phase-Thd (A)': 'B-Phase-Thd (A)',
  'V Line Neutral AVG (kW)': 'V Line Neutral AVG (kW)',
  'Active Export Day (kWh)': 'Active Export Day (kWh)',
  'Active Import Day (kWh)': 'Active Import Day (kWh)',
  'Lifetime Generation (KWh)': 'Lifetime Generation (KWh)',
  'Active Export Cumm. (kWh)': 'Active Export Cumm. (kWh)',
  'Active Import Cumm. (kWh)': 'Active Import Cumm. (kWh)',
  'Cumm. Active Export Cumm. (kWh)': 'Cumm. Active Export Cumm. (kWh)',
  'Cumm. Active Import Cumm. (kWh)': 'Cumm. Active Import Cumm. (kWh)',
  // INVERTER
  'AC Generation (kWh)': 'AC Generation (kWh)',
  'Load 1 (kW)': 'Load 1 (kW)',
  'Load 2 (kW)': 'Load 2 (kW)',
  'Load 3 (kW)': 'Load 3 (kW)',
  'AC Yield (kW)': 'AC Yield (kW)',
  'BOS loss (kW)': 'BOS loss (kW)',
  'DC Power (kW)': 'DC Power (kW)',
  'DC Yield (kW)': 'DC Yield (kW)',
  'DC Generation (kWh)': 'DC Generation (kWh)',
  'Down Time (kWh)': 'Down Time (kWh)',
  'Grid Lost': 'Grid Lost',
  'R-Phase (V)': 'R-Phase (V)',
  'Y-Phase (V)': 'Y-Phase (V)',
  'B-Phase (V)': 'B-Phase (V)',
  'Stop Time': 'Stop Time',
  'DC Current (A)': 'DC Current (A)',
  'DC Voltage (V)': 'DC Voltage (V)',
  'Efficiency (%)': 'Efficiency (%)',
  'Max Energy (kW)': 'Max Energy (kW)',
  'Min Energy (kW)': 'Min Energy (kW)',
  'Start Time': 'Start Time',
  'AC Power L1 (kW)': 'AC Power L1 (kW)',
  'AC Power L2 (kW)': 'AC Power L2 (kW)',
  'AC Power L3 (kW)': 'AC Power L3 (kW)',
  'Down Energy (kWh)': 'Down Energy (kWh)',
  'Energy Today (kWh)': 'Energy Today (kWh)',
  'Inv OP State': 'Inv OP State',
  'Working Hour': 'Working Hour',
  'Energy Import (kW)': 'Energy Import (kW)',
  'Inv Temp (°C)': 'Inv Temp (°C)',
  'R-Phase (A)': 'R-Phase (A)',
  'Y-Phase (A)': 'Y-Phase (A)',
  'B-Phase (A)': 'B-Phase (A)',
  'Min DC Energy (kW)': 'Min DC Energy (kW)',
  'Apparent Power (kW)': 'Apparent Power (kW)',
  'BOS Efficiency (%)': 'BOS Efficiency (%)',
  'Inverter Temp 2 (°C)': 'Inverter Temp 2 (°C)',
  'POA Irradiance (W/m²)': 'POA Irradiance (W/m²)',
  'Inv Status': 'Inv Status',
  'Leakage Current': 'Leakage Current',
  'Inverter Status 1': 'Inverter Status 1',
  'Inverter Status 2': 'Inverter Status 2',
  'Inverter Status 3': 'Inverter Status 3',
  'Inverter Status 4': 'Inverter Status 4',
  'Cumm. AC Generation (kWh)': 'Cumm. AC Generation (kWh)',
  'DC Cabinet Status': 'DC Cabinet Status',
  'Off Grid Frequency (Hz)': 'Off Grid Frequency (Hz)',
  'Total Working Hour': 'Total Working Hour',
  'Energy Import Daily (kW)': 'Energy Import Daily (kW)',
  'Lifetime Generation (KWh)': 'Lifetime Generation (KWh)',
  'DC Cabinet OC Status': 'DC Cabinet OC Status',
  // MFM
  'V Line Avg (V)': 'V Line Avg (V)',
  'Apparent Power Avg (kWA)': 'Apparent Power Avg (kWA)',
  'Total Avg Current (A)': 'Total Avg Current (A)',
  'V Line Neutral AVG (kW)': 'V Line Neutral AVG (kW)',
  'Power (kW)': 'Power (kW)',
  'Energy (kWh)': 'Energy (kWh)',
  'Channel (A)': 'Channel (A)',
  'Voltage (V)': 'Voltage (V)',
  'Over Volt': 'Over Volt',
  'Earth Trip': 'Earth Trip',
  'Phase Trip': 'Phase Trip',
  'Under Volt': 'Under Volt',
  'Unit Ready': 'Unit Ready',
  'Earth Fault': 'Earth Fault',
  'Fuse Failure': 'Fuse Failure',
  'Internal Fault': 'Internal Fault',
  'Breaker Status': 'Breaker Status',
  'SPD Status': 'SPD Status',
  'Total Current (A)': 'Total Current (A)',
  // SOIL SENSOR
  'ISC Ref (A)': 'ISC Ref (A)',
  'GEFF Ref (W/m²)': 'GEFF Ref (W/m²)',
  'ISC Test (A)': 'ISC Test (A)',
  'GEFF Test (W/m²)': 'GEFF Test (W/m²)',
  'Soil Ratio (%)': 'Soil Ratio (%)',
  'SP Daily Avg (%)': 'SP Daily Avg (%)',
  'SR Daily Avg (%)': 'SR Daily Avg (%)',
  'Percentage Ratio 1': 'Percentage Ratio 1',
  'Percentage Ratio 2': 'Percentage Ratio 2',
  'Soiling Ratio 1': 'Soiling Ratio 1',
  'Soiling Ratio 2': 'Soiling Ratio 2',
  'Transmit Loss 1': 'Transmit Loss 1',
  'Transmit Loss 2': 'Transmit Loss 2',
  'Ref Module Temp (°C)': 'Ref Module Temp (°C)',
  'Soil Percentage (%)': 'Soil Percentage (%)',
  'Test Module Temp (°C)': 'Test Module Temp (°C)',
  // TRACKER
  'Current (A)': 'Current (A)',
  'Accuracy (%)': 'Accuracy (%)',
  'Wind Speed (km/h)': 'Wind Speed (km/h)',
  'Mode Status': 'Mode Status',
  'Actual Angle (°)': 'Actual Angle (°)',
  'Error Status': 'Error Status',
  'Target Angle (°)': 'Target Angle (°)',
  'Input Voltage (V)': 'Input Voltage (V)',
  'Deviation Angle (°)': 'Deviation Angle (°)',
  // TRANSFORMER
  'PRV': 'PRV',
  'Mog Trip': 'Mog Trip',
  'Mog Alarm': 'Mog Alarm',
  'OT Trip Set (°C)': 'OT Trip Set (°C)',
  'WT Trip Set (°C)': 'WT Trip Set (°C)',
  'OT Alarm Set (°C)': 'OT Alarm Set (°C)',
  'WT Alarm Set (°C)': 'WT Alarm Set (°C)',
  'Actual OT (°C)': 'Actual OT (°C)',
  'Actual WT (°C)': 'Actual WT (°C)',
  'Buchloz Trip': 'Buchloz Trip',
  'Max OT (°C)': 'Max OT (°C)',
  'Max WT (°C)': 'Max WT (°C)',
  'Buchloz Alarm': 'Buchloz Alarm',
  // UPS
  'On Battery': 'On Battery',
  'Bypass': 'Bypass',
  'Health': 'Health',
  'Backup Time': 'Backup Time',
  'Load (kW)': 'Load (kW)',
  'Power Factor': 'Power Factor',
  'B-Phase (A)': 'B-Phase (A)',
  'Battery Current (A)': 'Battery Current (A)',
  'Battery Volt (V)': 'Battery Volt (V)',
  'Invalid Voltage (V)': 'Invalid Voltage (V)',
  'AC I/P Curr (A)': 'AC I/P Curr (A)',
  'AC I/P Volt (V)': 'AC I/P Volt (V)',
  'O/P Frequency (Hz)': 'O/P Frequency (Hz)',
  'AC O/P Curr (A)': 'AC O/P Curr (A)',
  'AC O/P Volt (V)': 'AC O/P Volt (V)',
  'Rectifier Voltage (V)': 'Rectifier Voltage (V)',
  'Battery Temperature (°C)': 'Battery Temperature (°C)',
  // WEATHER STATION
  'Humidity': 'Humidity',
  'Pressure (atms)': 'Pressure (atms)',
  'Pressure': 'Pressure',
  'Direction (deg)': 'Direction (deg)',
  'Direction': 'Direction',
  'Radiation (W/m²)': 'Radiation (W/m²)',
  'Radiation': 'Radiation',
  'Rain Gauge (mm)': 'Rain Gauge (mm)',
  'Rain Gauge': 'Rain Gauge',
  'Roll Angle (Radian)': 'Roll Angle (Radian)',
  'Roll Angle': 'Roll Angle',
  'Wind Speed (m/s)': 'Wind Speed (m/s)',
  'Wind Speed': 'Wind Speed',
  'Cloud Cover': 'Cloud Cover',
  'Module Temp (°C)': 'Module Temp (°C)',
  'Module Temp': 'Module Temp',
  'Pitch Angle (Radian)': 'Pitch Angle (Radian)',
  'Pitch Angle': 'Pitch Angle',
  'Ambient Temp (°C)': 'Ambient Temp (°C)',
  'Ambient Temp': 'Ambient Temp',
  'GHI Insolation (kWh/m²)': 'GHI Insolation (kWh/m²)',
  'GHI Insolation': 'GHI Insolation',
  'POA Insolation (kWh/m²)': 'POA Insolation (kWh/m²)',
  'POA Insolation': 'POA Insolation',
  'Aux Supply (V)': 'Aux Supply (V)',
  'Aux Supply': 'Aux Supply',
  'POA (W/m²)': 'POA (W/m²)',
  'POA': 'POA',
  'GHI (W/m²)': 'GHI (W/m²)',
  'GHI': 'GHI',
  // ZMU
  'DC Power (kW)': 'DC Power (kW)',
  'DC Current (A)': 'DC Current (A)',
  'DC Voltage (V)': 'DC Voltage (V)',
  'Total ZMU Power (kW)': 'Total ZMU Power (kW)',
  'Computed DC Power (kW)': 'Computed DC Power (kW)',
  'Total ZMU Current (A)': 'Total ZMU Current (A)',
  'Computed DC Current (A)': 'Computed DC Current (A)',
  'Total Computed ZMU Power (kW)': 'Total Computed ZMU Power (kW)',
  'Total Computed ZMU Current (A)': 'Total Computed ZMU Current (A)',
  // ERROR MESSAGES
  'Error': 'Error',
  'Warning': 'Warning',
  'Successful': 'Successful',
  'Success': 'Success',
  'Unknown Error': 'Unknown Error',
  'Not Found': 'Not Found',
  'Invalid date': 'Invalid date',
  'Unable to read cache components': 'Unable to read cache components',
  'Cache not found': 'Cache not found',
  'Cache could not be deleted': 'Cache could not be deleted',
  'Cannot update without condition': 'Cannot update without condition',
  'Something went wrong': 'Something went wrong',
  'Some error occured': 'Some error occured',
  'Error while reading data': 'Error while reading data',
  'Plants are not assigned to this user': 'Plants are not assigned to this user',
  'The specified key does not exist.': 'The specified key does not exist.',
  'Too many requests, please try again later.': 'Too many requests, please try again later.',
  'Not a Registered User': 'Not a Registered User',
  'Invalid Password': 'Invalid Password',
  'This Login Has Expired': 'This Login Has Expired',
  'Some issue in the server': 'Some issue in the server',
  'Date Limit Exceeded!': 'Date Limit Exceeded!',
  'Session has expired expired': 'Session has expired expired',
  'no records': 'no records',
  'Plant ID is required': 'Plant ID is required',
  'Block ID is required': 'Block ID is required',
  'Inverter room is required': 'Inverter room is required',
  'Index is required': 'Index is required',
  'Query param is required': 'Query param is required',
  'Date is required': 'Date is required',
  'Date from is required': 'Date from is required',
  'Date to is required': 'Date to is required',
  'Date from can not be greater than Date to': 'Date from can not be greater than Date to',
  'Starting date is required': 'Starting date is required',
  'Ending date is required': 'Ending date is required',
  'Component param is required': 'Component param is required',
  'Type is required': 'Type is required',
  'Type param is required': 'Type param is required',
  'Ending date required': 'Ending date required',
  'Starting date required': 'Starting date required',
  'Interval is required': 'Interval is required',
  'Module is required': 'Module is required',
  'Device is required': 'Device is required',
  'ID list is required': 'ID list is required',
  'Inverter ID is required': 'Inverter ID is required',
  'SCB ID is required': 'SCB ID is required',
  'WS ID is required': 'WS ID is required',
  'Search list is required': 'Search list is required',
  'Email is required': 'Email is required',
  'Not a valid email': 'Not a valid email',
  'The password must be 3+ chars long and contain a number': 'The password must be 3+ chars long and contain a number',
  'You are not allowed to make an API call': 'You are not allowed to make an API call',
  'Login expired': 'Login expired',
  'Alert updated successfully': 'Alert updated successfully',
  'Alert update failed!': 'Alert update failed!',
  'Please select a valid date': 'Please select a valid date',
  'Please select some option': 'Please select some option',
  'Changes were saved successfully': 'Changes were saved successfully',
  'Failed to save the changes': 'Failed to save the changes',
  'Please select String Inverters in order to check graph': 'Please select String Inverters in order to check graph',
  'No File To Download': 'No File To Download',
  'Template is successfully updated': 'Template is successfully updated',
  'There was some issue while making the change': 'There was some issue while making the change',
  'Template is successfully created': 'Template is successfully created',
  'Template has been deleted': 'Template has been deleted',
  'Forecasted Generation is not edited!': 'Forecasted Generation is not edited!',
  'Parameters are not configured': 'Parameters are not configured',
  'Please enter a valid Email': 'Please enter a valid Email',
  'Please check email for further instructions': 'Please check email for further instructions',
  'Please try again after': 'Please try again after',
  'Invalid email': 'Invalid email',
  'Please enter a valid date to view dashboard': 'Please enter a valid date to view dashboard',
  'Not-Connected channel cannot be selected': 'Not-Connected channel cannot be selected',
  'Please select atleast one SCB or Channel in order to plot graph': 'Please select atleast one SCB or Channel in order to plot graph',
  'Minimun one device will be selected': 'Minimun one device will be selected',
  'This link has expired': 'This link has expired',
  'Please fill new password and confirm password!': 'Please fill new password and confirm password!',
  'Password does not match': 'Password does not match',
  'Your password should not be same as your previous password': 'Your password should not be same as your previous password',
  'Password Successfully Updated! Email is sent with password in it': 'Password Successfully Updated! Email is sent with password in it',
  'Password Update Failed': 'Password Update Failed',
  'Your password is not strong. Please fulfill the criteria!': 'Your password is not strong. Please fulfill the criteria!',
  'Could not go back to login page, please try again': 'Could not go back to login page, please try again',
  'You have 10 days to reset the password': 'You have {num} days to reset the password',
  'Please Select Any Component': 'Please Select Any Component',
  'Minimun one tracker will be selected': 'Minimun one tracker will be selected',
  'No ZMU Configured': 'No ZMU Configured',
  'Please Select Channel/ZMU': 'Please Select Channel/ZMU'
};
